import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HomepageLayout } from '@shared/models/homepage-layout';
import { BaseComponent } from '@shared/shared/helpers/base-component';
import { SiteConfigService } from '@shared/shared/services/site-config.service';

@Component({
  selector: 'ten-prelogin-eligibility-popup',
  templateUrl: './prelogin-eligibility-popup.component.html',
  styleUrls: ['./prelogin-eligibility-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreloginEligibilityPopupComponent extends BaseComponent {
  public componentData: { version: string; layout: Array<HomepageLayout>; eligibility: any };

  constructor(
    siteConf: SiteConfigService,
    public dialogRef: MatDialogRef<PreloginEligibilityPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(siteConf, 'homepage');
  }

  public onClose(): void {
    this.dialogRef?.close();
  }
}
